const easternTimeZone = 'America/New_York';
const todayToken = 'today';

// Intl throws a RangeError when the browser has no IANA time zone data; fall back to the browser's local date.
let easternDateFormatter;
try {
    easternDateFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: easternTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
} catch (e) {
    easternDateFormatter = null;
}

function padToTwoDigits(value) {
    return value < 10 ? '0' + value : String(value);
}

/**
 * Current calendar date in the Eastern time zone, formatted as mm/dd/yyyy.
 * @returns {string}
 */
function getEasternTodayText() {
    const now = new Date();

    if (easternDateFormatter) {
        return easternDateFormatter.format(now);
    }

    return padToTwoDigits(now.getMonth() + 1) + '/' + padToTwoDigits(now.getDate()) + '/' + now.getFullYear();
}

/**
 * Current Eastern calendar date as a Date set to local midnight, for comparison against parsed input dates.
 * @returns {Date}
 */
function getEasternTodayDate() {
    const parts = getEasternTodayText().split('/');
    return new Date(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]));
}

/**
 * Resolves the "today" token used by date validation attributes. Server-rendered dates get baked into
 * Sitecore's HTML cache, so views emit the token and it is resolved here at validation/render time.
 * Any other value is returned unchanged.
 * @param {string} value
 * @returns {string}
 */
function resolveDateToken(value) {
    if (typeof value !== 'string') {
        return value;
    }

    return value.trim().toLowerCase() === todayToken ? getEasternTodayText() : value;
}

exports.getEasternTodayText = getEasternTodayText;
exports.getEasternTodayDate = getEasternTodayDate;
exports.resolveDateToken = resolveDateToken;
